import * as d3 from 'd3';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import * as setup from 'setup';
import Chart from '../Chart/Chart';

const axes = {
    labelX: 'Hands',
    labelY: '$',
    prefixY: '$',
    suffixY: '',
};

const maxX = Math.max(
    setup.charts.allIn.histogram.maxHands,
    setup.charts.meteredFunding.histogram.maxHands,
    setup.charts.spyOpponent.histogram.maxHands
);

const maxY = [
    setup.charts.allIn.hurricane.highlyUnlikely,
    setup.charts.meteredFunding.hurricane.highlyUnlikely,
    setup.charts.spyOpponent.hurricane.highlyUnlikely,
].reduce((max, band) => {
    const bandMax = _.max(band.map(point => point[0])) || 0;
    return Math.max(bandMax, max);
}, 0);

const strategies = [
    {
        ...setup.charts.allIn,
        bandColor: '#CA80DC',
        color: '#CE2A96',
        icon: 'M8 9.0625L10.4167 11.4792C10.5694 11.6319 10.7465 11.7049 10.9479 11.6979C11.1493 11.691 11.3264 11.6111 11.4792 11.4583C11.6319 11.3056 11.7083 11.1285 11.7083 10.9271C11.7083 10.7257 11.6319 10.5489 11.4792 10.3967L9.0625 7.98958L11.4792 5.5825C11.6319 5.43028 11.7083 5.25347 11.7083 5.05208C11.7083 4.85069 11.6319 4.67361 11.4792 4.52083C11.3264 4.36806 11.1493 4.29167 10.9479 4.29167C10.7465 4.29167 10.5694 4.36806 10.4167 4.52083L8 6.9375L5.58333 4.52083C5.43056 4.36806 5.25694 4.29167 5.0625 4.29167C4.86806 4.29167 4.69444 4.36806 4.54167 4.52083C4.38889 4.67361 4.3125 4.85069 4.3125 5.05208C4.3125 5.25347 4.38826 5.43056 4.53979 5.58333L6.9375 8L4.52083 10.4167C4.36806 10.5694 4.29514 10.7431 4.30208 10.9375C4.30903 11.1319 4.38889 11.3056 4.54167 11.4583C4.69444 11.6111 4.87153 11.6875 5.07292 11.6875C5.27431 11.6875 5.45076 11.6117 5.60229 11.4602L8 9.0625ZM8.00583 16C6.90472 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0767 0.625 11.105C0.208333 10.1333 0 9.09514 0 7.99042C0 6.88569 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92333 1.04167 4.895 0.625C5.86667 0.208333 6.90486 0 8.00958 0C9.11431 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92167 15.375 4.89C15.7917 5.85847 16 6.89319 16 7.99417C16 9.09528 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0783 14.9583 11.11 15.375C10.1415 15.7917 9.10681 16 8.00583 16Z',
    },
    {
        ...setup.charts.meteredFunding,
        bandColor: '#A1C6FF',
        color: '#6C60FF',
        icon: 'M6.9375 8.875L5.6875 7.64583C5.53472 7.49306 5.36111 7.41667 5.16667 7.41667C4.97222 7.41667 4.79861 7.49306 4.64583 7.64583C4.49306 7.79861 4.41667 7.9757 4.41667 8.17708C4.41667 8.37847 4.49306 8.55556 4.64583 8.70833L6.41667 10.4792C6.56944 10.6319 6.74306 10.7083 6.9375 10.7083C7.13194 10.7083 7.30556 10.6319 7.45833 10.4792L11.3542 6.58333C11.5069 6.43056 11.5833 6.25347 11.5833 6.05208C11.5833 5.85069 11.5069 5.67361 11.3542 5.52083C11.2014 5.36806 11.0278 5.29167 10.8333 5.29167C10.6389 5.29167 10.4653 5.36806 10.3125 5.52083L6.9375 8.875ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.07292 14.3854 2.34375 13.6562C1.61458 12.9271 1.04167 12.0764 0.625 11.1042C0.208333 10.1319 0 9.09722 0 8C0 6.88889 0.208333 5.85069 0.625 4.88542C1.04167 3.92014 1.61458 3.07292 2.34375 2.34375C3.07292 1.61458 3.92361 1.04167 4.89583 0.625C5.86806 0.208333 6.90278 0 8 0C9.11111 0 10.1493 0.208333 11.1146 0.625C12.0799 1.04167 12.9271 1.61458 13.6562 2.34375C14.3854 3.07292 14.9583 3.92014 15.375 4.88542C15.7917 5.85069 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3854 12.9271 13.6562 13.6562C12.9271 14.3854 12.0799 14.9583 11.1146 15.375C10.1493 15.7917 9.11111 16 8 16Z',
    },
];

export default function ComparisonChart() {
    const [chartRect, setChartRect] = useState<DOMRect>(new DOMRect());
    const [container, setContainer] = useState(d3.select(null));

    const containerRef = useCallback((ref: any) => {
        const newContainer = d3.select(ref);
        setContainer(newContainer);
    }, []);

    const scaleX = useMemo(() => {
        return d3
            .scaleLinear()
            .domain([0, maxX * 1.2])
            .range([0, chartRect.width]);
    }, [chartRect]);

    const scaleY = useMemo(() => {
        return d3
            .scaleLinear()
            .domain([0, maxY * 1.2])
            .range([chartRect.height, 0]);
    }, [chartRect]);

    useEffect(() => {
        // Empty container
        container.selectChildren().remove();

        // Check chart
        if (!chartRect.width) {
            return;
        }

        // Create band area function
        const getBandArea = d3
            .area()
            .curve(d3.curveCardinal.tension(0.2))
            .x((_, i) => scaleX(i))
            .y1(d => scaleY(d[0]))
            .y0(d => scaleY(d[1]));

        // Add bands
        container
            .selectAll('path.comparison-chart-band')
            .data(strategies)
            .enter()
            .append('path')
            .attr('class', 'comparison-chart-band')
            .attr('d', strategy => getBandArea(strategy.hurricane.highlyUnlikely))
            .attr('fill', strategy => strategy.bandColor)
            .attr('data-tooltip-id', 'chart-tooltip')
            .attr('data-tooltip-html', strategy => strategy.label);

        // Get lines data
        const linesData = strategies.map(strategy => ({
            ...strategy,
            width: scaleX(maxX) + 50,
            y: scaleY(strategy.histogram.mean),
        }));

        // Add lines
        container
            .selectAll('line.comparison-chart-line')
            .data(linesData)
            .enter()
            .append('line')
            .attr('class', 'comparison-chart-line')
            .attr('x1', 0)
            .attr('x2', line => line.width)
            .attr('y1', line => line.y)
            .attr('y2', line => line.y)
            .attr('stroke', line => line.color)
            .attr('stroke-width', 3)
            .attr('data-tooltip-id', 'chart-tooltip')
            .attr('data-tooltip-html', d => d.label);

        // Add line label
        container
            .selectAll('text.comparison-chart-line-label')
            .data(linesData)
            .enter()
            .append('text')
            .attr('class', 'comparison-chart-line-label')
            .attr('x', line => line.width)
            .attr('y', (line, index) => line.y + (index ? -15 : 15))
            .attr('dominant-baseline', (_, index) => (index ? 'hanging' : 'initial'))
            .attr('text-anchor', 'end')
            .text(line => `$${line.histogram.mean.toFixed(2)}`);

        // Add line icon
        container
            .selectAll('path.comparison-chart-line-icon')
            .data(linesData)
            .enter()
            .append('path')
            .attr('class', 'comparison-chart-line-icon')
            .attr('d', line => line.icon)
            .attr('fill', line => line.color)
            .attr('transform', (line, index) => `translate(${line.width + 8}, ${line.y + (index ? -20 : 4)})`);
    }, [chartRect, container, scaleX, scaleY]);

    return (
        <Chart
            axes={axes}
            legend={strategies}
            scaleX={scaleX}
            scaleY={scaleY}
            title="Comparison of the strategies"
            onRectChange={setChartRect}
        >
            <g ref={containerRef} />
        </Chart>
    );
}
